import { Pipe, PipeTransform } from '@angular/core';
import { DashboardWidget } from '../../viewmodels/dashboard/dashboard-widget';
import { WidgetDataType } from '../../views/dashboard/widgets/widget-data-type';

@Pipe({ name: 'widgetDateRangeValidator' })
export class WidgetDateRangeValidatorPipe implements PipeTransform {
  transform(dateEnd: Date, dateStart: Date, dashboardWidget: DashboardWidget): boolean {
    if (!dashboardWidget) {
      return false;
    }

    if (dashboardWidget.widget.widgetDataType !== WidgetDataType.MitigationsDueByMonth) {
      return true;
    }

    if (dateStart && dateEnd) {
      const result: boolean = dateStart < dateEnd;

      return result;
    }

    return false;
  }
}
